import type { HourlyFilters, HourlyUsage } from '../../usage.types';
import type IHourlyUsageRepository from '../IHourlyUsageRepository';
import API from '@repositories/Axios';
import type { Page } from '@type/Page';
import qs from 'qs';
import { injectable } from 'inversify';
import 'reflect-metadata';

@injectable()
export class HourlyUsageRepository implements IHourlyUsageRepository {
  async create(/* data: unknown */): Promise<HourlyUsage> {
    throw new Error('Method not implemented.');
  }
  async getList(queries?: HourlyFilters): Promise<Page<HourlyUsage>> {
    const queryString = qs.stringify(queries);

    const reuslt = await API.get<Page<HourlyUsage>>(`/api/v1/hourly-usages?${queryString}`);
    return reuslt.data;
  }
}
